import GameTagGeneric from './tag-generic.js';

const GameTagHot = ({ text }) => {
	return <GameTagGeneric text={text} bgColor="var(--hot-bg)" textColor="var(--hot-text)" />;
};

export default GameTagHot;
